/**
 * Authentication utilities, cookie-first sessions with legacy localStorage fallback.
 */

import { clearAllMemberLocalData } from '@/app/localStore';

const LEGACY_JWT_KEY = 'byonco_jwt';
const LEGACY_USER_KEY = 'byonco_user';

/**
 * TODO(remove-by-2026-10-01): Legacy localStorage JWT fallback for users
 * already logged in before cookie migration. Prefer httpOnly cookie only.
 */
export const getAuthToken = () => {
  return localStorage.getItem(LEGACY_JWT_KEY);
};

export const getUser = () => {
  const userStr = localStorage.getItem(LEGACY_USER_KEY);
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const isAuthenticated = () => {
  // Cookie presence cannot be read from JS (httpOnly); use AuthContext state.
  return !!getAuthToken() || !!getUser();
};

/** Clear local auth + medical/subscription caches (call after POST /logout). */
export const clearLocalAuthState = () => {
  localStorage.removeItem(LEGACY_JWT_KEY);
  localStorage.removeItem(LEGACY_USER_KEY);
  localStorage.removeItem('auth_token');
  localStorage.removeItem('token');
  localStorage.removeItem('subscription_status');
  localStorage.removeItem('byonco_subscription_status');
  localStorage.removeItem('byonco_patient_profile');
  localStorage.removeItem('byonco_second_opinion_usage_v1');
  localStorage.removeItem('byonco_second_opinion_entitlement_v1');
  localStorage.removeItem('byonco_ai_text_prompts');
  localStorage.removeItem('byonco_ai_file_prompts');
  // Case tokens
  Object.keys(localStorage)
    .filter((k) => k.startsWith('oncoagent_case_token_'))
    .forEach((k) => localStorage.removeItem(k));
  clearAllMemberLocalData();
};

export const logout = () => {
  clearLocalAuthState();
  window.location.href = '/';
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  // TODO(remove-by-2026-10-01): Bearer header only for legacy localStorage tokens
  return token ? { Authorization: `Bearer ${token}` } : {};
};
